import getLocalString from "constants/Localization";
import useBitumioMutation from "hooks/useBitumioMutation";
import { useUpdateOpportunityStatusMutation } from "generated/graphql";
import { useCallback } from "react";

export default function useUpdateOpportunityStatus() {
  const [mutation, { loading, data, error }] = useUpdateOpportunityStatusMutation();

  const [updateOpportunityStatusMutation, context] = useBitumioMutation(
    {
      mutation,
      loading,
      error,
      data,
      key: "updateOpportunityStatus",
    },
    {
      successMessage: getLocalString("opportunities.update-success"),
      failureMessage: getLocalString("opportunities.update-failure"),
    }
  );

  const updateOpportunityStatus = useCallback(
    (variables: { id: string; statusId: string }) => {
      return updateOpportunityStatusMutation({ variables });
    },
    [updateOpportunityStatusMutation]
  );

  return [updateOpportunityStatus, context] as const;
}
